/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTumorBoardOccurrenceParticipants } from 'app/entities/tumor-board-occurrence-participant/tumor-board-occurrence-participant.reducer';
import { getEntities as getTumorBoardOccurrences } from 'app/entities/tumor-board-occurrence/tumor-board-occurrence.reducer';
import { getEntities as getTumorBoardPatients } from 'app/entities/tumor-board-patient/tumor-board-patient.reducer';
import { MemberRole } from 'app/shared/model/enumerations/member-role.model';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-participant-outcome.reducer';

export const TumorBoardParticipantOutcomeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tumorBoardOccurrenceParticipants = useAppSelector(state => state.tumorBoardOccurrenceParticipant.entities);
  const tumorBoardOccurrences = useAppSelector(state => state.tumorBoardOccurrence.entities);
  const tumorBoardPatients = useAppSelector(state => state.tumorBoardPatient.entities);
  const tumorBoardParticipantOutcomeEntity = useAppSelector(state => state.tumorBoardParticipantOutcome.entity);
  const loading = useAppSelector(state => state.tumorBoardParticipantOutcome.loading);
  const updating = useAppSelector(state => state.tumorBoardParticipantOutcome.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardParticipantOutcome.updateSuccess);
  const memberRoleValues = Object.keys(MemberRole);

  const handleClose = () => {
    navigate(`/tumor-board-participant-outcome${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTumorBoardOccurrenceParticipants({}));
    dispatch(getTumorBoardOccurrences({}));
    dispatch(getTumorBoardPatients({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.joinedAt !== undefined && typeof values.joinedAt !== 'number') {
      values.joinedAt = Number(values.joinedAt);
    }
    if (values.leftAt !== undefined && typeof values.leftAt !== 'number') {
      values.leftAt = Number(values.leftAt);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardParticipantOutcomeEntity,
      ...values,
      boardMember: tumorBoardOccurrenceParticipants.find(it => it.id.toString() === values.boardMember?.toString()),
      occurrence: tumorBoardOccurrences.find(it => it.id.toString() === values.occurrence?.toString()),
      patient: tumorBoardPatients.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          memberRole: 'DOCTOR',
          ...tumorBoardParticipantOutcomeEntity,
          boardMember: tumorBoardParticipantOutcomeEntity?.boardMember?.id,
          occurrence: tumorBoardParticipantOutcomeEntity?.occurrence?.id,
          patient: tumorBoardParticipantOutcomeEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.tumorBoardParticipantOutcome.home.createOrEditLabel"
            data-cy="TumorBoardParticipantOutcomeCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.home.createOrEditLabel">
              Create or edit a TumorBoardParticipantOutcome
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-participant-outcome-id"
                  label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.joinedAt')}
                id="tumor-board-participant-outcome-joinedAt"
                name="joinedAt"
                data-cy="joinedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="joinedAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.joinedAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.leftAt')}
                id="tumor-board-participant-outcome-leftAt"
                name="leftAt"
                data-cy="leftAt"
                type="text"
              />
              <UncontrolledTooltip target="leftAtLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.leftAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.memberId')}
                id="tumor-board-participant-outcome-memberId"
                name="memberId"
                data-cy="memberId"
                type="text"
              />
              <UncontrolledTooltip target="memberIdLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.memberId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.memberRole')}
                id="tumor-board-participant-outcome-memberRole"
                name="memberRole"
                data-cy="memberRole"
                type="select"
              >
                {memberRoleValues.map(memberRole => (
                  <option value={memberRole} key={memberRole}>
                    {translate(`tinyMedicRestApp.MemberRole.${memberRole}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="memberRoleLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.memberRole" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.skipped')}
                id="tumor-board-participant-outcome-skipped"
                name="skipped"
                data-cy="skipped"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="skippedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.skipped" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.opinionSummary')}
                id="tumor-board-participant-outcome-opinionSummary"
                name="opinionSummary"
                data-cy="opinionSummary"
                type="text"
              />
              <UncontrolledTooltip target="opinionSummaryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.opinionSummary" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.active')}
                id="tumor-board-participant-outcome-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.cursor')}
                id="tumor-board-participant-outcome-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.lastUpdated')}
                id="tumor-board-participant-outcome-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.microSec')}
                id="tumor-board-participant-outcome-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.timestampEntry')}
                id="tumor-board-participant-outcome-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-participant-outcome-boardMember"
                name="boardMember"
                data-cy="boardMember"
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.boardMember')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardOccurrenceParticipants
                  ? tumorBoardOccurrenceParticipants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-participant-outcome-occurrence"
                name="occurrence"
                data-cy="occurrence"
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.occurrence')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardOccurrences
                  ? tumorBoardOccurrences.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-participant-outcome-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.patient')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardPatients
                  ? tumorBoardPatients.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tumor-board-participant-outcome"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardParticipantOutcomeUpdate;
